import React, { useContext } from 'react';
import { AnchorWithLink } from 'atoms/Anchor';
import { ButtonComp } from 'atoms/Buttons';
import ImageComponent from 'atoms/Image';
import { useDispatch, useSelector } from 'react-redux';
import GreenTickImage from 'styles/staticAssets/images/GREEN_RIGHT_TICK.svg';
import SEARCH_STORE_CONSTANTS from '../Constants/SearchStoreConstants';
import {
  getChannels,
  checkTodayDay,
  setOrderNowAnalyticsData,
  setOrderLaterAnalyticsData,
} from '../SearchStoreUtilities/SearchStoreUtils';
import START_ORDER_CONSTANTS from '../../StartOrderComponent/Constants/startOrderConstants';
import { UserOrderContext } from 'context/context';
import { withRouter } from 'react-router-dom';
import { createBasketsAction, qrCodeScanTimeAction } from '@kfc-global/react-shared/redux/Actions/CartAction';
import { setUserParams } from '@kfc-global/react-shared/redux/Actions/AppStateAction';
import {
  isEmptyEvery,
  isEmptyObject,
  setSearchStoreByAtrribute,
  getFullAddressDetails,
  getDispositionTypeOnAPIFormat,
  createBasketData,
  getValueOrDefaultObject,
  getTernaryValue,
  getValueOrDefaultArray,
  getAndCheckIfOneTrue,
  getAndCheck,
} from 'common/utilities/utils';
import { getFacilities } from 'common/utilities/amenities';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import FavoriteUnfillImage from 'styles/staticAssets/images/favorite-unfilled.svg';
import FavoriteFillImage from 'styles/staticAssets/images/favorite-filled.svg';
import { getList } from 'organisms/ScheduleOrder/ScheduleOrderUtils/ScheduleOrderUtils';
import SCHEDULE_ORDER_SAMPLE_DATA from 'organisms/ScheduleOrder/Data/SampleData';

const orderItems = orderTypesObj => {
  return (
    !!isEmptyObject(orderTypesObj) &&
    orderTypesObj.map((item, index) => {
      const { PICK_UP, TAKE_AWAY } = SEARCH_STORE_CONSTANTS;
      return (
        <div className='store-order-options' key={index}>
          <span>
            <ImageComponent data-testid='' srcFile={GreenTickImage} alt={'tick'} className='tick-image' />
          </span>
          <span>{item === PICK_UP ? translateWithI18Next(TAKE_AWAY) : item}</span>
        </div>
      );
    })
  );
};

export const getMiles = (mi, tenantReducer) => {
  if (tenantReducer?.country?.toUpperCase() === 'INDIA') {
    return `${(parseFloat(mi) / 1000).toFixed(1)} ${tenantReducer?.storeSearch?.distanceMetrics}`;
  }
  return (parseFloat(mi) / 1600).toFixed(1) + ' mi';
};

const SearchStoreCard = props => {
  const {
    storeDistance: mi = '',
    addresses = {},
    isOpen = false,
    buttonData = {},
    map = {},
    storeName = '',
    currentMarket,
    storeInfo = {},
    channels = [],
    storeStatus = {},
    onStoreSelectFinish,
    onClickMapHandler,
    isMapView,
    isMobile,
    isFavoriteStore,
    addToFavoriteHandler,
    removeFromFavoriteHandler,
    loggedIn,
    centerIndex,
    storeLength,
  } = props;
  const { buttonText: buttonTextSchedule = '' } = getValueOrDefaultObject(
    buttonData?.scheduleOrderButtonData,
  );
  const { buttonText: buttonTextOrder = '', display: displayOrder = false } = getValueOrDefaultObject(
    buttonData?.orderNowButtonData,
  );
  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext);
  const {
    SCHEDULE_ORDER_DATA = '',
    SEARCH_ORDER_DATA = '',
    SELECTED_TILE_DATA = '',
    SCHEDULE_ORDER_TIME_DATA = '',
    MENU_URL,
    SET_DISPOSITION,
    USER_LOCALIZED,
    CURRENT_STORE_INFO,
    SCHEDULE_ORDER_TIME_PRESERVE_TIME,
    SET_FORCERELOAD,
  } = START_ORDER_CONSTANTS;
  const { STORE_STATUS_CLOSED } = SEARCH_STORE_CONSTANTS;
  const { mapText = '' } = map;

  /* orderNow logic for getting time */

  const { timingsSampleData = {} } = SCHEDULE_ORDER_SAMPLE_DATA;

  //call to extract web channels
  const webChannel = channels && getChannels(channels);
  const { services: orderTypes = [] } = getValueOrDefaultArray(webChannel[0]);
  const { operatingHours = [] } = storeStatus?.timings?.operatingHours ? storeStatus.timings : [];
  const timimgMsg = checkTodayDay(isOpen, operatingHours);
  const dispatch = useDispatch();
  const profileReducer = useSelector(data => data.profileReducer);
  /* istanbul ignore next */
  const tenantReducer = useSelector(data => data.tenantReducer);
  /* istanbul ignore next */
  const { dispositionType = localStorage.getItem('dispositionType') } = userOrderState.dispositionStateData;
  const { allowScheduleOrder } = tenantReducer.componentOptions.ScheduledDeliveryComponent;

  /* istanbul ignore next */
  let userParams = useSelector(data => data.appStateReducer.userStatus);
  const dispositionNew = isEmptyEvery(userOrderState.dispositionNew)
    ? JSON.parse(localStorage.getItem('dispositionNew'))
    : userOrderState.dispositionNew;

  /* redirect to menu page function */
  const gotoMenuPage = (storeInfoObj, dateTimeObj) => {
    let store = getTernaryValue(storeInfoObj, storeInfoObj, null);
    userOrderStateDispatch({ type: SELECTED_TILE_DATA, value: { selectedData: {} } });
    // update currently selected store info
    localStorage.setItem('currentStoreInfo', JSON.stringify(store));
    userOrderStateDispatch({
      type: CURRENT_STORE_INFO,
      value: store,
    });
    dispatch(
      setUserParams({
        ...userParams,
        localized: true,
      }),
    );
    userOrderStateDispatch({
      type: SCHEDULE_ORDER_TIME_DATA,
      value: { selectedDateTime: dateTimeObj },
    });
    userOrderStateDispatch({
      type: SCHEDULE_ORDER_TIME_PRESERVE_TIME,
      value: { selectContentTime: 'ASAP' },
    });
    userOrderStateDispatch({
      type: SET_FORCERELOAD,
      value: { forceReload: true },
    });
    localStorage.setItem('tenantReducer', JSON.stringify(tenantReducer));
    localStorage.setItem('selectedTile', JSON.stringify({}));
    localStorage.setItem('dispositionType', dispositionType);
    localStorage.setItem('storeInfo', JSON.stringify(store));
    localStorage.setItem('dateTimeOrder', JSON.stringify(dateTimeObj));
    localStorage.setItem('savedTimeOrder', 'ASAP');
    setTimeout(() => {
      !userOrderState.fromPdpPage &&
        props.history.push({
          pathname: `${MENU_URL}`,
        });
    }, 500);
  };
  const scheduleOrderDispatches = storeInfoObj => {
    let store = getTernaryValue(storeInfoObj, storeInfoObj, null);
    userOrderStateDispatch({ type: SELECTED_TILE_DATA, value: { selectedData: {} } });
    // update currently selected store info
    localStorage.setItem('currentStoreInfo', JSON.stringify(store));
    userOrderStateDispatch({
      type: CURRENT_STORE_INFO,
      value: store,
    });
  };
  /** Method to handle order now button click */
  const orderNowButtonClickHandler = async (e, selectedStoreInfo) => {
    e.preventDefault();
    e.stopPropagation();
    setOrderNowAnalyticsData();

    /* newly added code for order now logic */
    const {
      futureDates,
      scheduled: initiallyScheduled,
      asap,
    } = getAndCheckIfOneTrue(selectedStoreInfo?.summary?.timings, timingsSampleData);
    const { interval: initialInterval = 0, startEndTime = {} } = getAndCheck(
      initiallyScheduled?.periods?.length,
      initiallyScheduled.periods[0],
    );
    const { from: initialDayStartTime, to: initialDayEndTime } = startEndTime;

    getList(
      initialDayStartTime,
      initialDayEndTime,
      initialInterval,
      asap?.isAvailable,
      futureDates.length === 1 && tenantReducer?.country === 'INDIA',
    );

    let dateTimeObj = {
      time: 'ASAP',
      interval: selectedStoreInfo.summary.timings.scheduled.periods[0]?.interval,
      date: new Date(),
      selectedTime: 'ASAP',
    };
    if (
      dispositionNew === null ||
      dispositionNew.type !== dispositionType ||
      dispositionNew.store.id !== selectedStoreInfo.id ||
      dispositionNew.deliveryAddress !== userOrderState?.scheduleOrderData?.deliveryAddress
    ) {
      let obj = await createBasketData(
        selectedStoreInfo,
        getDispositionTypeOnAPIFormat(dispositionType),
        profileReducer.customerId,
        dateTimeObj,
      );
      dispatch(qrCodeScanTimeAction(''));
      dispatch(createBasketsAction({ data: obj, tenantId: tenantReducer.tenantId }));
    }
    localStorage.setItem('renderComp', true);
    userOrderStateDispatch({
      type: SET_DISPOSITION,
      value: {
        oldvalue: dispositionNew,
        newValue: {
          type: dispositionType,
          store: selectedStoreInfo,
          date: dateTimeObj.date,
          time: dateTimeObj.time,
          interval: dateTimeObj.interval,
          selectedTime: dateTimeObj.selectedTime,
          deliveryAddress: userOrderState?.scheduleOrderData?.deliveryAddress,
        },
      },
    });
    localStorage.setItem('dispositionOld', JSON.stringify(dispositionNew));
    localStorage.setItem(
      'dispositionNew',
      JSON.stringify({
        type: dispositionType,
        store: selectedStoreInfo,
        date: dateTimeObj.date,
        time: dateTimeObj.time,
        selectedTime: dateTimeObj.selectedTime,
        interval: dateTimeObj.interval,
        deliveryAddress: userOrderState?.scheduleOrderData?.deliveryAddress,
      }),
    );
    setSearchStoreByAtrribute();
    const payload = {
      storeID: selectedStoreInfo?.id,
      disposition: dispositionType,
      postCode: selectedStoreInfo?.addresses[0]?.address?.pinCode,
    };
    onStoreSelectFinish(payload);

    userOrderStateDispatch({ type: SEARCH_ORDER_DATA, value: { showSearchStore: false } });
    userOrderStateDispatch({
      type: USER_LOCALIZED,
      value: { isLocalized: true },
    });
    gotoMenuPage(selectedStoreInfo, dateTimeObj);
  };

  /** Method to handle schedule order button click */
  const scheduleOrderButtonClickHandler = (e, selectedStoreInfo) => {
    console.log('{{ }} schedule order button click', {
      event: e,
      store: selectedStoreInfo,
      module: selectedStoreInfo?.module,
    });

    e.preventDefault();
    e.stopPropagation();
    userOrderStateDispatch({
      type: USER_LOCALIZED,
      value: { isLocalized: true },
    });
    userOrderStateDispatch({
      type: SCHEDULE_ORDER_DATA,
      value: { showScheduleOrderCatering: true, selectedStoreInfo: selectedStoreInfo },
    });
    userOrderStateDispatch({
      type: SEARCH_ORDER_DATA,
      value: { showSearchStore: false },
    });
    const {
      futureDates,
      scheduled: initiallyScheduled,
      asap,
    } = getAndCheckIfOneTrue(selectedStoreInfo?.summary?.timings, timingsSampleData);
    const { interval: initialInterval = 0, startEndTime = {} } = getAndCheck(
      initiallyScheduled?.periods?.length,
      initiallyScheduled.periods[0],
    );
    const { from: initialDayStartTime, to: initialDayEndTime } = startEndTime;

    getList(
      initialDayStartTime,
      initialDayEndTime,
      initialInterval,
      asap?.isAvailable,
      futureDates.length === 1 && tenantReducer?.country === 'INDIA',
    );
    setOrderLaterAnalyticsData();
    scheduleOrderDispatches(selectedStoreInfo);
  };

  const facilities = getFacilities(storeInfo);

  const getStyles = () => {
    if (isMapView && isMobile) {
      return {
        margin: '0',
        position: 'absolute',
        'max-height': '325px',
        bottom: '0',
      };
    }
  };

  const renderElement = (
    <div
      className={`store-card ${getAndCheck(isMapView, !isMobile) ? 'store-card-map-view' : 'store-card-mobile-view'}`}
      style={getStyles()}
      data-testid='store-card'
      id='map-store-card'
    >
      <div className='d-flex'>
        <div className={`store-dist-container ${isMapView && 'map-view'}`}>
          <div className='store-name-container'>
            <span className='card-store-name'>{storeName}</span>
          </div>
          <span className='store-distance'>{getMiles(mi, tenantReducer)}</span>
        </div>
        {isMapView && <span className='store-index'>{`${centerIndex + 1} of ${storeLength}`}</span>}
      </div>
      <div className='card-content'>
        <div className='order-items'>{orderItems(orderTypes)}</div>
        <div className={'w-100'}>
          <span className='store-address'>{getFullAddressDetails(addresses)}</span>
          {!isMapView && (
            <span className='map-link' data-testid='map-handler' onClick={() => onClickMapHandler()}>
              <AnchorWithLink className='card-map-link'>{mapText}</AnchorWithLink>
            </span>
          )}
        </div>
        <div className={`info-timing ${!isOpen && 'info-timingClosed'}`}>
          {isOpen ? '' : <span>{translateWithI18Next(STORE_STATUS_CLOSED)}</span>}
          <span className={`${!isOpen && 'list-circle'}`}>{timimgMsg}</span>
        </div>

        <div className='facilities'>
          {facilities &&
            facilities.map(item => {
              return (
                <ImageComponent
                  key={item.key}
                  data-testid=''
                  srcFile={item.image}
                  alt={item.label || ''}
                  className='facility-img'
                  title={item.label}
                />
              );
            })}
        </div>
      </div>
      <div className='w-100 d-flex mt-2 searchstoreBtn'>
        { loggedIn ? (
            (( isFavoriteStore && (
              <ImageComponent
                data-testid='favorite-img'
                srcFile={FavoriteFillImage}
                alt={'favorite'}
                className='favorite-img'
                onClick={() => removeFromFavoriteHandler()}
              />
            )) || (
              <ImageComponent
                data-testid='unfavorite-img'
                srcFile={FavoriteUnfillImage}
                alt={'favorite'}
                className='favorite-img'
                onClick={() => addToFavoriteHandler()}
              />
            ))
          ) : (
            ''
          )}
        {displayOrder && isOpen && (
          <ButtonComp
            data-testid='order-now'
            className={`button redButton search-store-card-btn ${isMapView && !isMobile ? 'cardMapView' : null}`}
            onClickHandler={event => orderNowButtonClickHandler(event, storeInfo)}
          >
            {buttonTextOrder}
          </ButtonComp>
        )}
        {allowScheduleOrder && (
          <ButtonComp
            data-testid='schedule-order'
            className={`button whiteButton blackBorder search-store-card-btn schedule-order-btn ${
              getAndCheck(isMapView, !isMobile) ? 'cardMapView' : null
            }`}
            onClickHandler={e => scheduleOrderButtonClickHandler(e, storeInfo)}
          >
            {buttonTextSchedule}
          </ButtonComp>
        )}
      </div>
    </div>
  );
  return currentMarket === SEARCH_STORE_CONSTANTS.COUNTRY_CODE_INDIA && !isOpen ? null : renderElement;
};

export default withRouter(SearchStoreCard);
